import { IonCard, IonRow } from '@ionic/react';

import { mergeClassNames } from '@/utils/mergeClassNames';

import styles from './RadioSelectButtonGroup.module.css';

import { Icon, IconName } from '../Icon';

interface RadioSelectButtonGroupProps {
  activeId: string;
  onChange: (id: string) => void;
  options: Array<{ id: string; label: string; icon: IconName }>;
}

export const RadioSelectButtonGroup = ({ activeId, onChange, options }: RadioSelectButtonGroupProps) => {
  const isActive = (id: string) => id === activeId;

  return (
    <div className={styles.options}>
      {options.map((option) => (
        <IonCard
          button
          className={mergeClassNames(styles.option, isActive(option.id) && styles.active)}
          key={option.id}
          onClick={() => onChange(option.id)}>
          <div className={styles.content}>
            <Icon color={isActive(option.id) ? '#229B8A' : '#90C953'} height={35} name={option.icon} width={24} />
            {option.label}
          </div>
        </IonCard>
      ))}
    </div>
  );
};
